{
  "footer": {
    "alreadyPartner": "Уже являетесь партнером?",
    "back": "Назад",
    "letsgo": "Начнем",
    "login": "Вход",
    "next": "Далее",
    "readMore": "Узнать больше",
    "signUp": "Регистрация"
  },
  "formErrors": {
    "address": "Этот адрес не найден. Введите существующий адрес",
    "businessName": "Это имя недоступно. Пожалуйста, выберите другое",
    "email": "Этот адрес электронной почты уже используется",
    "verificationCode": "Неверный код",
    "turnstileToken": "Проверка безопасности не пройдена. Пожалуйста, попробуйте снова."
  },
  "global": {
    "title": "Присоединиться к Treatwell"
  },
  "input": {
    "businessName": {
      "invalid": "Название компании слишком длинное",
      "label": "Название Компании",
      "required": "Обязательно"
    },
    "businessSegment": {
      "aesthetics": "Эстетическая косметология",
      "barber": "Барбер",
      "beautician": "Косметолог",
      "hair-removal": "Удаление волос",
      "hairdresser": "Парикмахер",
      "massage": "Массаж",
      "nails": "Ногти",
      "primary": "Основная",
      "required": "Выберите как минимум один вариант",
      "spa": "Спа"
    },
    "businessType": {
      "dedicatedSpaceCheckbox": "Я могу подтвердить, что у меня есть специализированное и отдельное помещение для моего бизнеса.",
      "home": "На дому <0>- ваши клиенты приходят к вам домой</0>",
      "mobile": "Мобильно <0>- вы приезжаете к клиентам домой</0>",
      "mobileCheckbox": "Я хочу использовать Treatwell ТОЛЬКО как программное обеспечение для бронирования, а НЕ как торговую площадку.",
      "mobileMessage": "К сожалению, из-за ограничений на нашем маркетплейсе могут быть представлены только компании с постоянным адресом.",
      "required": "Выберите один вариант",
      "shop": "Мастерская <0>- ваши клиенты приходят в мастерскую</0>"
    },
    "city": {
      "invalid": "Название города слишком длинное",
      "label": "Город",
      "required": "Обязательно"
    },
    "country": {
      "label": "Страна",
      "required": "Обязательно"
    },
    "email": {
      "invalid": "Недействительный",
      "label": "Емейл",
      "required": "Обязательно"
    },
    "firstName": {
      "invalid": "Пожалуйста, не используйте специальные символы",
      "label": "Имя",
      "required": "Обязательно"
    },
    "lastName": {
      "invalid": "Пожалуйста, не используйте специальные символы",
      "label": "Фамилия",
      "required": "Обязательно"
    },
    "marketing": {
      "label": "Я бы хотел(а) получать email-рассылки с советами экспертов для развития моего бизнеса."
    },
    "password": {
      "hint": "Минимум 8 символов",
      "invalid": "Пароль должен содержать не менее 8 символов",
      "label": "Пароль",
      "required": "Обязательно"
    },
    "phoneNumber": {
      "invalid": "Недействительный номер телефона",
      "label": "Номер телефона",
      "required": "Обязательно"
    },
    "postalCode": {
      "invalid": "Почтовый индекс слишком длинный",
      "label": "Почтовый индекс",
      "required": "Обязательно"
    },
    "privacy": {
      "label": "Создавая Freemium Аккаунт, вы соглашаетесь с нашей <0>политикой конфиденциальности</0> и <1>условиями и положениями</1>"
    },
    "searchBusiness": {
      "label": "Найти компанию"
    },
    "street": {
      "invalid": "Адрес слишком длинный",
      "label": "Адрес",
      "required": "Обязательно"
    }
  },
  "salesMode": {
    "enterPassword": "Введите пароль для режима продаж",
    "invalidPassword": "Недействительный пароль"
  },
  "stepContext": {
    "attractNewClients": "Привлекать новых клиентов",
    "buildRelationships": "Построить крепкие отношения со своими клиентами",
    "growBusiness": "Развивать свой бизнес красиво",
    "manageAppointments": "Управлять записями к вам на прием в любом удобном месте",
    "prompt": "Всего несколько простых шагов (и около 3 минут) отделяют вас от того, чтобы присоединиться к более чем 75 000 салонов, которые управляют своим бизнесом, расширяют клиентскую базу и увеличивают доход.<br /><br /> С Treatwell вы сможете:",
    "prompt2": "...и многое другое.",
    "title": "<0>Присоединиться к Treatwell</0> - Крупнейшей в Европе платформе для парикмахерских и салонов красоты - еще никогда не было так просто."
  },
  "stepCounter": {
    "step0": "Шаг 1",
    "step1": "Шаг 1",
    "step2": "Шаг 2",
    "step3": "Шаг 3",
    "step4": "Шаг 4",
    "step5": "Поздравляем"
  },
  "stepEmailVerification": {
    "rateLimited": "Вы запросили слишком много кодов. Используйте код, который мы уже отправили вам на почту, или повторите попытку через несколько минут.",
    "resend": "Переотправить",
    "subTitle1": "Просто введите код, чтобы завершить регистрацию.",
    "subTitle2": "Ничего не получили?",
    "title": "<0>Почти готово,</0> мы отправили вам письмо с 6-значным кодом!"
  },
  "stepError": {
    "accountCreation": "создание вашего аккаунта",
    "body": "У нас возникли проблемы.\nПожалуйста, подождите минуту и попробуйте еще раз.",
    "bodyWithError": "У нас возникли проблемы с {{reason}}.\nПожалуйста, подождите минуту и попробуйте еще раз.",
    "button": "Попробовать еще раз",
    "title": "Ой, что-то пошло не так!"
  },
  "stepFinal": {
    "joke1Punchline": "Шампудель!",
    "joke1Setup": "Какая собака у парикмахера?",
    "joke2Punchline": "Он срезал путь!",
    "joke2Setup": "Как парикмахеру удалось выиграть гонку?",
    "joke3Punchline": "Барберкью!",
    "joke3Setup": "Как называется очередь из мужчин, ожидающих стрижки?",
    "joke4Punchline": "Он их затмевает!",
    "joke4Setup": "Как стрижет волосы человек на Луне?",
    "joke5Punchline": "stepFinal.joke5Punchline",
    "joke5Setup": "stepFinal.joke5Setup",
    "subTitle": "Пока вы ждете, вот вам несколько лохматых шуток",
    "title": "Спасибо, давайте настроим ваш бизнес!<br /> Дайте нам <0>две минуты...</0>"
  },
  "stepFinalRedirectLogin": {
    "alternativeButton": "Регистрация",
    "alternativeMessage": "Вы используете то же местоположение для регистрации нового бизнеса?",
    "button": "Вход в Treatwell",
    "message": "<0>Хорошие новости!</0> Ваш бизнес уже настроен в Treatwell."
  },
  "stepFourForm": {
    "prompt1": "Мы используем эту информацию для создания вашей учетной записи и свяжемся с вами, если возникнет необходимость.",
    "title": "Расскажите нам о себе"
  },
  "stepOneForm": {
    "prompt1": "Найдите или введите название вашей компании",
    "title": "Расскажите нам о своем бизнесе"
  },
  "stepOneSearch": {
    "addManually": "Не можете найти свой бизнес? <0>Добавьте его вручную</0>",
    "prompt1": "Введите название вашей компании",
    "title": "Расскажите нам о своем бизнесе"
  },
  "stepThreeForm": {
    "title": "Какая у вас модель бизнеса?"
  },
  "stepTwoForm": {
    "prompt1": "Выберите все подходящие варианты, укажите сначала основную услугу",
    "title": "Какие услуги вы предлагаете?"
  },
  "stepTurnstile": {
    "title": "Почти готово!",
    "description": "Пожалуйста, пройдите проверку безопасности ниже для входа.",
    "loading": "Загрузка проверки безопасности…",
    "validationError": "Пожалуйста, пройдите проверку безопасности"
  }
}
